import { DeviceSize } from "constants/deviceSize";

export enum ThemeName {
  Light = "light",
  Dark = "dark",
}

export type Palette = Record<string, Record<string, string>>;

export interface Theme {
  name: ThemeName;
  breakpoints: typeof DeviceSize;
  palette: Palette;
  typography: ThemeTypography;
}

export type TypographyVariant =
  | "title1"
  | "subtitle1"
  | "subtitle2"
  | "body1"
  | "body2"
  | "body3"
  | "body4"
  | "body5"
  | "body6"
  | "body7"
  | "checkbox"
  | "link1";

export type Typography = {
  [key in TypographyVariant]: {
    fontSize: string;
    lineHeight: string;
    fontWeight: string;
  };
};

export type ThemeTypography = {
  desktop: Typography;
  mobile: Typography;
};

